import { apiBaseURL } from '../ProjectConstants';

/*
 =-=-=-=-=- data structure -=-=-=-=-=
    locationId: int
*/
async function handleDelDeliveryLocations(locationId, fetch) {
    
    const response = await fetch.delete(`${apiBaseURL}/api/DeliveryLocation?id=${locationId}`);
    const isDataGood = response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model';

    console.log('handleDelDeliveryLocations locationId', locationId);
    console.log('handleDelDeliveryLocations response', response);

    return {
        response,
        isDataGood
    };
}
export default handleDelDeliveryLocations;